import { Color } from './color_models';
import { colors } from './color_definitions';

export const colorNames = colors.map(c => c.name);

const colorMap = new Map<string, Color>();
for (const color of colors) {
  colorMap.set(color.name, color);
}

export function getColorWarnings(colorName: string): string[] {
  const color = colorMap.get(colorName);
  if (!color) {
    throw Error(`Unknown color ${colorName}.`);
  }

  const warnings: string[] = [];

  if (color.expires) {
    warnings.push(`Utgår ${color.expires}.`);
  }

  if (color.limitedWarranty) {
    warnings.push('Corinor gir ingen garanti mot synlige skjøter, riper og fingermerker.');
  }

  if (color.marble) {
    warnings.push('Marmormønster eller varierende styrke og størrelse på spettene.');
  }

  if (color.strength) {
    warnings.push('Varierende styrke og størrelse på spettene.');
  }

  if (color.scratches) {
    warnings.push('Riper og fingermerker kan oppleves som mer fremtredende enn andre kjøkkenfarger.');
  }

  if (color.limitedBending) {
    warnings.push('Begrensede bøyemuligheter.');
  }

  if (color.translucent) {
    warnings.push('Lysgjennomskinnelig.');
  }

  return warnings;
}
